import { text_colorTextPrimary } from 'ext-ui/style/colors'
import { layout_defaultContentSpacing, spacing } from 'ext-ui/style/spacing'
import {
  font_family_weight_medium,
  font_family_weight_regular,
  font_size_lg,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  display: flex;
  flex-direction: column;
  gap: ${layout_defaultContentSpacing};
  align-items: center;
  justify-content: center;
  height: 100%;

  .TasksComplete-rocketship {
    filter: drop-shadow(-4.32px 10.8px 5.4px rgba(0, 0, 0, 0.2));
  }

  .TasksComplete-message {
    display: flex;
    flex-direction: column;
    gap: ${spacing(3)};

    &-title {
      text-align: center;
      color: ${text_colorTextPrimary};
      font-family: ${font_family_weight_medium};
      font-size: ${font_size_lg};
      line-height: 20px;
    }

    &-body {
      text-align: center;
      color: ${text_colorTextPrimary};
      font-family: ${font_family_weight_regular};
      font-size: ${font_size_lg};
      line-height: 20px;
    }
  }
`
